import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import AuthCardLayout from 'layouts/AuthCardLayout';

const TrialExpired = () => {
  const { t } = useTranslation();
  const { logout, isAuthenticated } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <AuthCardLayout>
      <div className="text-center">
        <FontAwesomeIcon
          icon={faClock}
          className="text-warning mb-3"
          style={{ fontSize: '3rem' }}
        />
        <h3 className="mb-3">{t('TRIAL_EXPIRED.TITLE')}</h3>
        <p className="text-700 mb-2">
          {t('TRIAL_EXPIRED.THANK_YOU')}
        </p>
        <p className="text-700 mb-4">
          {t('TRIAL_EXPIRED.MESSAGE')}
        </p>
        <hr />
        <p className="text-600 fs--1 mb-4">
          {t('TRIAL_EXPIRED.CONTACT')}
        </p>
        <div className="d-flex justify-content-center gap-2">
          <a href="mailto:soporte@gestodo.com" className="btn btn-primary btn-sm">
            {t('TRIAL_EXPIRED.CONTACT_BUTTON')}
          </a>
          {isAuthenticated() && (
            <Button variant="falcon-default" size="sm" onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} className="me-1" />
              {t('TRIAL_EXPIRED.LOGOUT')}
            </Button>
          )}
          {!isAuthenticated() && (
            <Link className="btn btn-falcon-default btn-sm" to="/login">
              {t('TRIAL_EXPIRED.BACK_TO_LOGIN')}
            </Link>
          )}
        </div>
      </div>
    </AuthCardLayout>
  );
};

export default TrialExpired;
